import React, { Component } from 'react'
import '../../../css/components/Button/Button.css'

class Button extends Component {
  render() {
    let { className, onClick, loading } = this.props;
    let classes = `button ${className}`;
    if (loading) {
      classes += ' is-loading';
    }
    return (
      <button type="button" className={classes} onClick={onClick} 
        disabled={loading || this.props.disabled}>
        {this.props.children}
      </button>
    )
  }
}

export default Button



// WEBPACK FOOTER //
// ./src/components/Button/Button.js